export enum LayoutOptions {
  HAS_SIDENAV = 'hasSidenav',
  HAS_TOP_BANNER = 'hasTopBanner',
  /**
   * The footer strip, the Issues tab and the floating console. Meant for a route that carries the
   * app version, read from the merged activated-route data so every page under it inherits it: the
   * issues check posts against `:appVersionId`, so the block has nothing to do where there is none.
   */
  HAS_FOOTER = 'hasFooter',
  IS_RUNNING_INSTANCE = 'isRunningInstance',
}
